import React from 'react';
import {
	GroupBase,
	ValueContainerProps,
	components,
	OptionProps,
	ClearIndicatorProps,
	DropdownIndicatorProps,
} from 'react-select';
import './custom-multi-select-dropdown.style.scss';
import { ICustomDropdownOption } from '.';
import CloseIcon from 'src/assets/svg/close-icon';
import BottomArrowUTEModal from 'src/assets/svg/bottom-arrow';
import { ModulesEnumValue } from 'src/modules/grant-access/grant-access.model';

export const ValueComponent: React.FC<ValueContainerProps<any, boolean, GroupBase<any>>> = ({ children, ...props }) => {
	const { hasValue, selectProps } = props;

	const getStylesForSelectedModules = (moduleValue: number) => {
		switch (moduleValue) {
			case ModulesEnumValue.Home:
				return 'module module-home';
			case ModulesEnumValue.Documents:
				return 'module module-documents';
			case ModulesEnumValue.TaxPayments:
				return 'module module-tax-payments';
			case ModulesEnumValue.DistributeK1s:
				return 'module module-distribute-k1s';

			default:
				return 'module';
		}
	};

	const onRemoveOption = (selectedOption: ICustomDropdownOption) => {
		const newValue = selectProps.value.filter((option: ICustomDropdownOption) => option.value !== selectedOption.value);
		selectProps.onChange(newValue, {
			action: 'remove-value',
			removedValue: { value: selectedOption.value, label: selectedOption.label },
		});
	};

	if (!hasValue) {
		return (
			<components.ValueContainer {...props}>
				{<div className='custom-multi-select-placeholder'>{selectProps.placeholder}</div>}
				{React.Children.map(children, (child: any) => {
					return child?.props.id === 'clickableInput' ? child : null;
				})}
			</components.ValueContainer>
		);
	}

	let itemsToShow;
	if (selectProps.value.length === 5) {
		itemsToShow = selectProps.menuIsOpen ? selectProps.value : selectProps.value.slice(0, 3);
	} else {
		itemsToShow = selectProps.menuIsOpen ? selectProps.value : selectProps.value.slice(0, 2);
	}

	return (
		<components.ValueContainer {...props}>
			{
				<>
					{itemsToShow.map((option: ICustomDropdownOption) => {
						if (option.value === -1) return;
						return (
							<span className={getStylesForSelectedModules(option.value)}>
								{option.label}
								<CloseIcon onClick={() => onRemoveOption(option)} />
							</span>
						);
					})}
					{!selectProps.menuIsOpen && selectProps.value.length == 5 && <span className='moreItems'>+2 more</span>}
					{!selectProps.menuIsOpen && selectProps.value.length < 5 && selectProps.value.length > 2 && (
						<span className='moreItems'>+1 more</span>
					)}
				</>
			}
			{React.Children.map(children, (child: any) => {
				return child?.props.id === 'clickableInput' ? child : null;
			})}
		</components.ValueContainer>
	);
};

export const OptionComponent: React.FC<OptionProps<any, boolean, GroupBase<any>>> = (props) => {
	return (
		<div>
			<components.Option {...props}>
				<div className='option-container'>
					<input
						className='option-container_input'
						type='checkbox'
						checked={props.isSelected}
						onChange={() => null}
					/>
					<label className='option-container_label'>{props.label}</label>
				</div>
			</components.Option>
		</div>
	);
};

export const DropdownIndicator: React.FC<DropdownIndicatorProps<any, boolean, GroupBase<any>>> = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<BottomArrowUTEModal />
		</components.DropdownIndicator>
	);
};

export const ClearIndicator: React.FC<ClearIndicatorProps<any, boolean, GroupBase<any>>> = (props) => {
	return (
		<components.ClearIndicator {...props}>
			<CloseIcon />
		</components.ClearIndicator>
	);
};
